<h4>
    All ranges
    <fluent-button appearance="stealth" (click)="listNames()">
        <i class="fas fa-sync"></i>
    </fluent-button>
</h4>

<div style="height: 1px; flex: 1; overflow: hidden">
    <wj-flex-grid #grid style="height: 100%" [isReadOnly]="true" headersVisibility="Column"
                  (initialized)="onGridInitialized($event)"
                  (dblclick)="showRange()" (contextmenu)="onGridContextMenu($event)">
        <wj-flex-grid-column [header]="'Name'" [binding]="'name'" [width]="140" [minWidth]="120"></wj-flex-grid-column>
        <wj-flex-grid-column [header]="'Scope'" [binding]="'scope'" [visible]="false"></wj-flex-grid-column>
        <wj-flex-grid-column [header]="'Sheet'" [binding]="'sheet'" [width]="100"></wj-flex-grid-column>
        <wj-flex-grid-column [header]="'Formula'" [binding]="'formula'" width="*"></wj-flex-grid-column>
        <wj-flex-grid-filter #gridFilter></wj-flex-grid-filter>
    </wj-flex-grid>
</div>

<div class="toolbar">
<wj-flex-grid-search placeholder="Search key(s)" style="flex: 1"
                     [grid]="grid">
</wj-flex-grid-search>
</div>
